import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE_AGENT } from '@utils/helpers'

const memberListAgentAdminRoutes = {
  path: 'member-list-agent-admin',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.memberAgent.list'),
  },
  children: [
    {
      path: '',
      name: 'memberListAgentAdmin',
      component: () =>
        lazyLoadView(import('@views/MemberListAgentAdmin/list.vue')),
      meta: {
        authRequired: ROLE_AGENT,
      },
    },
    {
      path: ':id/:agent_id',
      name: 'memberListAgentAdminDetail',
      component: () =>
        lazyLoadView(import('@views/MemberListAgentAdmin/detail.vue')),
      meta: {
        authRequired: ROLE_AGENT,
        label: i18n.t('router.memberAgent.details'),
      },
    },
  ],
}

export default memberListAgentAdminRoutes
